import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { PhoneNumberModule } from '../../pipes/phone-number.module';
import { LoginPageRoutingModule } from './loginpage-routing.module';
import { MatRadioModule } from '@angular/material/radio';
import { RecaptchaModule, RECAPTCHA_LANGUAGE } from 'ng-recaptcha';
import { MatTooltipModule } from '@angular/material/tooltip';

import { LoginpageComponent } from './loginpage.component';
import { FaqHomePageComponent } from 'src/app/components/faq-home-page/faq-home-page.component';
import { LoginComponent } from 'src/app/components/login/login.component';
import { IbanModule } from 'src/app/pipes/iban.module';
import { TransactionDateModule } from 'src/app/pipes/transaction-date.module';

import { AmountModule } from 'src/app/pipes/amount.module';
import { CentralDateModule } from 'src/app/pipes/central-date.module';

import { CoinSymbolModule } from 'src/app/pipes/coin-symbol.module';
import { LoginAppComponent } from '../../components/login-app/login-app.component';
import { AccountModule } from 'src/app/pipes/account.module';

// AoT requires an exported function for factories
export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PhoneNumberModule,
    IbanModule,
    AccountModule,
    MatRadioModule,
    MatTooltipModule,
    LoginPageRoutingModule,
    RecaptchaModule,
    TransactionDateModule,
    CentralDateModule,
    AmountModule,
    CoinSymbolModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  declarations: [
    LoginpageComponent,
    FaqHomePageComponent,
    LoginComponent,
    LoginAppComponent
  ],
  providers: [
    {
      provide: RECAPTCHA_LANGUAGE,
      useValue: localStorage.getItem('language'),
    }
  ],
  entryComponents: [],
  bootstrap: [LoginpageComponent]
})
export class LoginPageModule {}
